var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoicon2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.014,
    height: 7.059,
    viewBox: "0 0 12.014 7.059",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.8 0H1.314A1.318 1.318 0 000 1.314v4.43a1.318 1.318 0 001.314 1.314H6.8a1.318 1.318 0 001.314-1.314v-4.43A1.31 1.31 0 006.8 0zM11.041.723a.67.67 0 00-.223.092L8.767 1.998v3.05l2.064 1.183a.781.781 0 001.078-.289.8.8 0 00.105-.394V1.486a.791.791 0 00-.973-.763z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoicon2);
export default __webpack_public_path__ + "static/media/videoicon2.d14165e6dd99b37733c5fbd3de352723.svg";
export { ForwardRef as ReactComponent };